var _g, _g2, _g3, _g4, _g5, _path, _path2, _g6, _path3, _path4, _path5, _g7, _g8, _path6, _g9, _g10, _path7, _g11, _g12, _path8, _g13, _g14, _path9, _g15, _g16, _path10, _g17, _g18, _path11, _g19, _g20, _path12, _g21, _path13, _g22, _g23, _path14, _g24, _g25, _path15, _g26, _path16, _g27, _path17, _g28, _g29, _path18, _g30, _g31, _path19, _g32, _g33, _path20, _g34, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiRaidFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 823,
    height: 539,
    viewBox: "0 0 823 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_1751)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 444.537C496.199 444.537 545 395.736 545 335.537C545 275.338 496.199 226.537 436 226.537C375.801 226.537 327 275.338 327 335.537C327 395.736 375.801 444.537 436 444.537Z",
    stroke: "#555659",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 483.537C517.738 483.537 584 417.275 584 335.537C584 253.799 517.738 187.537 436 187.537C354.262 187.537 288 253.799 288 335.537C288 417.275 354.262 483.537 436 483.537Z",
    stroke: "#555659",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 523.537C539.83 523.537 624 439.367 624 335.537C624 231.708 539.83 147.537 436 147.537C332.17 147.537 248 231.708 248 335.537C248 439.367 332.17 523.537 436 523.537Z",
    stroke: "#555659",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "20 20"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_230_1751)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_230_1751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 253,
    width: 199,
    height: 199
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.387 451.293C490.998 451.293 535.269 407.022 535.269 352.411C535.269 297.8 490.998 253.529 436.387 253.529C381.776 253.529 337.505 297.8 337.505 352.411C337.505 407.022 381.776 451.293 436.387 451.293Z",
    fill: "black"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.269 253.529H337.505V451.293H535.269V253.529Z",
    fill: "black"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 439C492.885 439 539 392.885 539 336C539 279.115 492.885 233 436 233C379.115 233 333 279.115 333 336C333 392.885 379.115 439 436 439Z",
    fill: "#5A65EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 376,
    y: 293,
    width: 120,
    height: 86
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 293H376V379H496V293Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.562 379C464.562 379 460.863 374.598 457.781 370.707C471.24 366.919 476.377 358.524 476.377 358.524C472.165 361.288 468.157 363.234 464.562 364.564C459.425 366.714 454.493 368.148 449.665 368.967C439.801 370.81 430.76 370.298 423.055 368.864C417.199 367.738 412.164 366.1 407.952 364.462C405.589 363.541 403.021 362.414 400.452 360.981C400.144 360.776 399.836 360.674 399.527 360.469C399.322 360.367 399.219 360.264 399.116 360.162C397.267 359.138 396.24 358.421 396.24 358.421C396.24 358.421 401.171 366.612 414.219 370.502C411.137 374.393 407.336 379 407.336 379C384.63 378.283 376 363.438 376 363.438C376 330.472 390.794 303.751 390.794 303.751C405.589 292.694 419.665 293.001 419.665 293.001L420.692 294.229C402.199 299.553 393.671 307.641 393.671 307.641C393.671 307.641 395.931 306.413 399.733 304.672C410.726 299.86 419.459 298.529 423.055 298.222C423.671 298.12 424.185 298.017 424.801 298.017C431.068 297.198 438.157 296.994 445.555 297.813C455.315 298.939 465.795 301.806 476.479 307.641C476.479 307.641 468.363 299.963 450.897 294.639L452.335 293.001C452.335 293.001 466.411 292.694 481.205 303.751C481.205 303.751 496 330.472 496 363.438C496 363.438 487.267 378.283 464.562 379ZM416.788 331.189C410.931 331.189 406.308 336.307 406.308 342.553C406.308 348.798 411.034 353.917 416.788 353.917C422.644 353.917 427.267 348.798 427.267 342.553C427.37 336.307 422.644 331.189 416.788 331.189ZM454.288 331.189C448.432 331.189 443.808 336.307 443.808 342.553C443.808 348.798 448.534 353.917 454.288 353.917C460.144 353.917 464.767 348.798 464.767 342.553C464.767 336.307 460.144 331.189 454.288 331.189Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 87.5L539 192",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M446.5 97.5L444 166",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298 182L259 108",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.445 198.222C323.445 190.368 317.077 184 309.222 184C301.368 184 295 190.368 295 198.222V198.223C295 206.078 301.368 212.445 309.222 212.445C317.077 212.445 323.445 206.078 323.445 198.223V198.222Z",
    fill: "url(#paint0_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.445 198.222C322.445 190.92 316.525 185 309.222 185C301.92 185 296 190.92 296 198.222V198.223C296 205.525 301.92 211.445 309.222 211.445C316.525 211.445 322.445 205.525 322.445 198.223V198.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.912 192.066L308.433 190.674C308.803 190.561 309.198 190.557 309.571 190.663L314.549 192.086C315.408 192.331 316 193.116 316 194.009V200.572C316 201.161 315.741 201.719 315.292 202.099L310.745 205.946C310.02 206.56 308.964 206.579 308.218 205.992L303.264 202.101C302.782 201.721 302.5 201.142 302.5 200.528V193.977C302.5 193.099 303.073 192.324 303.912 192.066Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.04 192.022L309.372 190.021C309.279 189.993 309.179 189.993 309.086 190.021L302.417 192.022C302.315 192.052 302.225 192.115 302.161 192.201C302.097 192.287 302.063 192.391 302.062 192.499V199.834C302.062 200.788 302.449 201.764 303.21 202.736C303.792 203.479 304.597 204.224 305.603 204.952C307.292 206.175 308.955 206.925 309.025 206.957C309.089 206.985 309.159 207 309.229 207C309.299 207 309.368 206.985 309.432 206.957C309.502 206.925 311.166 206.175 312.855 204.952C313.861 204.224 314.665 203.479 315.247 202.736C316.009 201.764 316.395 200.788 316.395 199.834V192.499C316.395 192.391 316.361 192.287 316.297 192.201C316.233 192.115 316.143 192.052 316.04 192.022ZM315.399 199.834C315.399 201.522 313.705 203.105 312.284 204.136C311.01 205.06 309.717 205.716 309.229 205.952C308.74 205.716 307.448 205.06 306.174 204.136C304.753 203.105 303.059 201.522 303.059 199.834V192.869L309.229 191.018L315.399 192.869V199.834Z",
    fill: "black"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.445 184.222C457.445 176.368 451.077 170 443.222 170C435.368 170 429 176.368 429 184.222V184.223C429 192.078 435.368 198.445 443.222 198.445C451.077 198.445 457.445 192.078 457.445 184.223V184.222Z",
    fill: "url(#paint1_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.445 184.222C456.445 176.92 450.525 171 443.222 171C435.92 171 430 176.92 430 184.222V184.223C430 191.525 435.92 197.445 443.222 197.445C450.525 197.445 456.445 191.525 456.445 184.223V184.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.912 178.066L442.433 176.674C442.803 176.561 443.198 176.557 443.571 176.663L448.549 178.086C449.408 178.331 450 179.116 450 180.009V186.572C450 187.161 449.741 187.719 449.292 188.099L444.745 191.946C444.02 192.56 442.964 192.579 442.218 191.992L437.264 188.101C436.782 187.721 436.5 187.142 436.5 186.528V179.977C436.5 179.099 437.073 178.324 437.912 178.066Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M450.04 178.022L443.372 176.021C443.279 175.993 443.179 175.993 443.086 176.021L436.417 178.022C436.315 178.052 436.225 178.115 436.161 178.201C436.097 178.287 436.063 178.391 436.062 178.499V185.834C436.062 186.788 436.449 187.764 437.21 188.736C437.792 189.479 438.597 190.224 439.603 190.952C441.292 192.175 442.955 192.925 443.025 192.957C443.089 192.985 443.159 193 443.229 193C443.299 193 443.368 192.985 443.432 192.957C443.502 192.925 445.166 192.175 446.855 190.952C447.861 190.224 448.665 189.479 449.247 188.736C450.009 187.764 450.395 186.788 450.395 185.834V178.499C450.395 178.391 450.361 178.287 450.297 178.201C450.233 178.115 450.143 178.052 450.04 178.022ZM449.399 185.834C449.399 187.522 447.705 189.105 446.284 190.136C445.01 191.06 443.717 191.716 443.229 191.952C442.74 191.716 441.448 191.06 440.174 190.136C438.753 189.105 437.059 187.522 437.059 185.834V178.869L443.229 177.018L449.399 178.869V185.834Z",
    fill: "black"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.445 297.222C303.445 289.368 297.077 283 289.222 283C281.368 283 275 289.368 275 297.222V297.223C275 305.078 281.368 311.445 289.222 311.445C297.077 311.445 303.445 305.078 303.445 297.223V297.222Z",
    fill: "url(#paint2_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.445 297.222C302.445 289.92 296.525 284 289.222 284C281.92 284 276 289.92 276 297.222V297.223C276 304.525 281.92 310.445 289.222 310.445C296.525 310.445 302.445 304.525 302.445 297.223V297.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.912 291.066L288.433 289.674C288.803 289.561 289.198 289.557 289.571 289.663L294.549 291.086C295.408 291.331 296 292.116 296 293.009V299.572C296 300.161 295.741 300.719 295.292 301.099L290.745 304.946C290.02 305.56 288.964 305.579 288.218 304.992L283.264 301.101C282.782 300.721 282.5 300.142 282.5 299.528V292.977C282.5 292.099 283.073 291.324 283.912 291.066Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.04 291.022L289.372 289.021C289.279 288.993 289.179 288.993 289.086 289.021L282.417 291.022C282.315 291.052 282.225 291.115 282.161 291.201C282.097 291.287 282.063 291.391 282.062 291.499V298.834C282.062 299.788 282.449 300.764 283.21 301.736C283.792 302.479 284.597 303.224 285.603 303.952C287.292 305.175 288.955 305.925 289.025 305.957C289.089 305.985 289.159 306 289.229 306C289.299 306 289.368 305.985 289.432 305.957C289.502 305.925 291.166 305.175 292.855 303.952C293.861 303.224 294.665 302.479 295.247 301.736C296.009 300.764 296.395 299.788 296.395 298.834V291.499C296.395 291.391 296.361 291.287 296.297 291.201C296.233 291.115 296.143 291.052 296.04 291.022ZM295.399 298.834C295.399 300.522 293.705 302.105 292.284 303.136C291.01 304.06 289.717 304.716 289.229 304.952C288.74 304.716 287.448 304.06 286.174 303.136C284.753 302.105 283.059 300.522 283.059 298.834V291.869L289.229 290.018L295.399 291.869V298.834Z",
    fill: "black"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.445 326.222C639.445 318.368 633.077 312 625.222 312C617.368 312 611 318.368 611 326.222V326.223C611 334.078 617.368 340.445 625.222 340.445C633.077 340.445 639.445 334.078 639.445 326.223V326.222Z",
    fill: "url(#paint3_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.445 326.222C638.445 318.92 632.525 313 625.222 313C617.92 313 612 318.92 612 326.222V326.223C612 333.525 617.92 339.445 625.222 339.445C632.525 339.445 638.445 333.525 638.445 326.223V326.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.912 320.066L624.433 318.674C624.803 318.561 625.198 318.557 625.571 318.663L630.549 320.086C631.408 320.331 632 321.116 632 322.009V328.572C632 329.161 631.741 329.719 631.292 330.099L626.745 333.946C626.02 334.56 624.964 334.579 624.218 333.992L619.264 330.101C618.782 329.721 618.5 329.142 618.5 328.528V321.977C618.5 321.099 619.073 320.324 619.912 320.066Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M632.04 320.022L625.372 318.021C625.279 317.993 625.179 317.993 625.086 318.021L618.417 320.022C618.315 320.052 618.225 320.115 618.161 320.201C618.097 320.287 618.063 320.391 618.062 320.499V327.834C618.062 328.788 618.449 329.764 619.21 330.736C619.792 331.479 620.597 332.224 621.603 332.952C623.292 334.175 624.955 334.925 625.025 334.957C625.089 334.985 625.159 335 625.229 335C625.299 335 625.368 334.985 625.432 334.957C625.502 334.925 627.166 334.175 628.855 332.952C629.861 332.224 630.665 331.479 631.247 330.736C632.009 329.764 632.395 328.788 632.395 327.834V320.499C632.395 320.391 632.361 320.287 632.297 320.201C632.233 320.115 632.143 320.052 632.04 320.022ZM631.399 327.834C631.399 329.522 629.705 331.105 628.284 332.136C627.01 333.06 625.717 333.716 625.229 333.952C624.74 333.716 623.448 333.06 622.174 332.136C620.753 331.105 619.059 329.522 619.059 327.834V320.869L625.229 319.018L631.399 320.869V327.834Z",
    fill: "black"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.001 413.778C287.001 402.609 277.947 393.555 266.778 393.555C255.61 393.555 246.556 402.609 246.556 413.778V413.778C246.556 424.947 255.61 434 266.778 434C277.947 434 287.001 424.947 287.001 413.778V413.778Z",
    fill: "url(#paint4_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.001 413.778C286.001 403.161 277.395 394.555 266.778 394.555C256.162 394.555 247.556 403.161 247.556 413.778V413.778C247.556 424.394 256.162 433 266.778 433C277.395 433 286.001 424.394 286.001 413.778V413.778Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.632 405.206L265.895 402.971C266.265 402.857 266.66 402.854 267.032 402.96L274.964 405.226C275.823 405.471 276.415 406.256 276.415 407.149V417.51C276.415 418.098 276.156 418.657 275.707 419.037L268.418 425.204C267.693 425.818 266.637 425.837 265.89 425.25L257.984 419.038C257.502 418.659 257.22 418.079 257.22 417.465V407.118C257.22 406.24 257.792 405.464 258.632 405.206Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.468 404.96L266.987 402.116C266.854 402.076 266.713 402.076 266.58 402.116L257.098 404.96C256.953 405.004 256.825 405.094 256.734 405.216C256.643 405.338 256.594 405.486 256.594 405.639V416.068C256.594 417.425 257.143 418.813 258.226 420.195C259.053 421.251 260.198 422.311 261.627 423.346C264.029 425.085 266.394 426.151 266.494 426.196C266.585 426.237 266.684 426.258 266.783 426.258C266.883 426.258 266.982 426.237 267.073 426.196C267.172 426.151 269.537 425.085 271.939 423.346C273.369 422.311 274.513 421.251 275.341 420.195C276.424 418.813 276.973 417.425 276.973 416.068V405.639C276.973 405.486 276.924 405.338 276.833 405.216C276.742 405.094 276.614 405.004 276.468 404.96ZM275.557 416.068C275.557 418.469 273.148 420.72 271.127 422.186C269.315 423.5 267.478 424.432 266.783 424.767C266.089 424.432 264.251 423.5 262.44 422.186C260.419 420.72 258.01 418.469 258.01 416.068V406.165L266.783 403.533L275.557 406.165V416.068Z",
    fill: "black"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.445 403.222C594.445 392.054 585.391 383 574.222 383C563.054 383 554 392.054 554 403.222V403.223C554 414.391 563.054 423.445 574.222 423.445C585.391 423.445 594.445 414.391 594.445 403.223V403.222Z",
    fill: "url(#paint5_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.445 403.222C593.445 392.606 584.839 384 574.222 384C563.606 384 555 392.606 555 403.222V403.223C555 413.839 563.606 422.445 574.222 422.445C584.839 422.445 593.445 413.839 593.445 403.223V403.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.076 394.652L573.339 392.417C573.709 392.303 574.104 392.299 574.477 392.405L582.409 394.671C583.267 394.917 583.859 395.702 583.859 396.595V406.955C583.859 407.543 583.6 408.102 583.151 408.482L575.862 414.65C575.137 415.263 574.081 415.282 573.335 414.695L565.428 408.483C564.946 408.104 564.664 407.524 564.664 406.911V396.563C564.664 395.685 565.237 394.91 566.076 394.652Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M583.913 394.406L574.431 391.561C574.298 391.521 574.157 391.521 574.024 391.561L564.543 394.406C564.397 394.449 564.269 394.539 564.178 394.661C564.087 394.783 564.038 394.932 564.038 395.084V405.513C564.038 406.87 564.587 408.259 565.67 409.641C566.498 410.696 567.642 411.756 569.072 412.791C571.474 414.53 573.839 415.597 573.938 415.641C574.029 415.682 574.128 415.703 574.228 415.703C574.327 415.703 574.426 415.682 574.517 415.641C574.617 415.597 576.982 414.53 579.384 412.791C580.813 411.756 581.958 410.696 582.785 409.641C583.868 408.259 584.417 406.87 584.417 405.513V395.084C584.417 394.932 584.368 394.783 584.277 394.661C584.186 394.539 584.058 394.449 583.913 394.406ZM583.001 405.513C583.001 407.914 580.592 410.165 578.571 411.631C576.76 412.945 574.922 413.877 574.228 414.212C573.533 413.877 571.696 412.945 569.884 411.631C567.863 410.165 565.454 407.914 565.454 405.513V395.611L574.228 392.979L583.001 395.611V405.513Z",
    fill: "black"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.445 212.222C542.445 201.054 533.391 192 522.222 192C511.054 192 502 201.054 502 212.222V212.223C502 223.391 511.054 232.445 522.222 232.445C533.391 232.445 542.445 223.391 542.445 212.223V212.222Z",
    fill: "url(#paint6_linear_230_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.445 212.222C541.445 201.606 532.839 193 522.222 193C511.606 193 503 201.606 503 212.222V212.223C503 222.839 511.606 231.445 522.222 231.445C532.839 231.445 541.445 222.839 541.445 212.223V212.222Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.076 203.652L521.339 201.417C521.709 201.303 522.104 201.299 522.477 201.405L530.409 203.671C531.267 203.917 531.859 204.702 531.859 205.595V215.955C531.859 216.543 531.6 217.102 531.151 217.482L523.862 223.65C523.137 224.263 522.081 224.282 521.335 223.695L513.428 217.483C512.946 217.104 512.664 216.524 512.664 215.911V205.563C512.664 204.685 513.237 203.91 514.076 203.652Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M531.913 203.406L522.431 200.561C522.298 200.521 522.157 200.521 522.024 200.561L512.543 203.406C512.397 203.449 512.269 203.539 512.178 203.661C512.087 203.783 512.038 203.932 512.038 204.084V214.513C512.038 215.87 512.587 217.259 513.67 218.641C514.498 219.696 515.642 220.756 517.072 221.791C519.474 223.53 521.839 224.597 521.938 224.641C522.029 224.682 522.128 224.703 522.228 224.703C522.327 224.703 522.426 224.682 522.517 224.641C522.617 224.597 524.982 223.53 527.384 221.791C528.813 220.756 529.958 219.696 530.785 218.641C531.868 217.259 532.417 215.87 532.417 214.513V204.084C532.417 203.932 532.368 203.783 532.277 203.661C532.186 203.539 532.058 203.449 531.913 203.406ZM531.001 214.513C531.001 216.914 528.592 219.165 526.571 220.631C524.76 221.945 522.922 222.877 522.228 223.212C521.533 222.877 519.696 221.945 517.884 220.631C515.863 219.165 513.454 216.914 513.454 214.513V204.611L522.228 201.979L531.001 204.611V214.513Z",
    fill: "black"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.75 76.5C462.733 76.5 476.5 62.7328 476.5 45.75C476.5 28.7672 462.733 15 445.75 15C428.767 15 415 28.7672 415 45.75C415 62.7328 428.767 76.5 445.75 76.5Z",
    fill: "#69B5E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 422,
    y: 22,
    width: 47,
    height: 47
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M469 45.75C469 32.9094 458.591 22.5 445.75 22.5C432.909 22.5 422.5 32.9094 422.5 45.75C422.5 58.5906 432.909 69 445.75 69C458.591 69 469 58.5906 469 45.75Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.5 22.5H469V69H422.5V22.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.645 22.5H422.5V22.6453H422.645V22.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 53.0156H435.578V54.4688H455.922V53.0156ZM455.922 54.4688H435.578V55.9219H455.922V54.4688ZM455.922 55.9219H435.578V57.375H455.922V55.9219ZM455.922 57.375H435.578V58.8281H455.922V57.375ZM438.484 58.8281H435.578V60.2812H438.484V58.8281ZM455.922 58.8281H439.938V60.2812H455.922V58.8281ZM438.484 60.2812H435.578V61.7344H438.484V60.2812ZM455.922 60.2812H439.938V61.7344H455.922V60.2812ZM438.484 61.7344H435.578V63.1875H438.484V61.7344ZM455.922 61.7344H439.938V63.1875H455.922V61.7344ZM438.484 63.1875H435.578V64.6406H438.484V63.1875ZM455.922 63.1875H439.938V64.6406H455.922V63.1875ZM438.484 64.6406H435.578V66.0938H438.484V64.6406ZM455.922 64.6406H439.938V66.0938H455.922V64.6406ZM438.484 66.0938H435.578V67.5469H438.484V66.0938ZM455.922 66.0938H439.938V67.5469H455.922V66.0938ZM438.484 67.5469H435.578V69H438.484V67.5469ZM455.922 67.5469H439.938V69H455.922V67.5469Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 57.375H448.656V58.8281H450.109V57.375ZM447.203 58.8281H442.844V60.2812H447.203V58.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.656 58.8281H447.203V60.2812H448.656V58.8281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 58.8281H448.656V60.2812H450.109V58.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 58.8281H450.109V60.2812H451.562V58.8281Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.844 60.2812H441.391V61.7345H442.844V60.2812ZM445.75 60.2812H444.297V61.7345H445.75V60.2812Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.203 60.2812H445.75V61.7345H447.203V60.2812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 60.2812H447.203V61.7345H450.109V60.2812ZM442.844 61.7345H441.391V63.1875H442.844V61.7345ZM445.75 61.7345H444.297V63.1875H445.75V61.7345Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.656 61.7344H445.75V63.1875H448.656V61.7344Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 61.7344H448.656V63.1875H450.109V61.7344ZM445.75 63.1875H444.297V64.6406H445.75V63.1875ZM450.109 63.1875H448.656V64.6406H450.109V63.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.844 26.8594H441.391V28.3125H442.844V26.8594ZM448.656 26.8594H444.297V28.3125H448.656V26.8594ZM450.109 28.3125H439.938V29.7656H450.109V28.3125ZM450.109 29.7656H438.484V31.2188H450.109V29.7656Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.938 31.2188H437.031V32.6719H439.938V31.2188Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 31.2188H439.938V32.6719H450.109V31.2188Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 31.2188H450.109V32.6719H454.469V31.2188ZM444.297 32.6719H435.578V34.125H444.297V32.6719Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 32.6719H444.297V34.125H450.109V32.6719Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 32.6719H450.109V34.125H455.922V32.6719ZM448.656 34.125H435.578V35.5781H448.656V34.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.109 34.125H448.656V35.5781H450.109V34.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 34.125H450.109V35.5781H455.922V34.125ZM457.375 35.5781H434.125V37.0312H457.375V35.5781ZM457.375 37.0312H434.125V38.4844H457.375V37.0312ZM457.375 38.4844H434.125V39.9375H457.375V38.4844ZM457.375 39.9375H434.125V41.3906H457.375V39.9375ZM457.375 41.3906H434.125V42.8438H457.375V41.3906ZM457.375 42.8438H434.125V44.2969H457.375V42.8438ZM457.375 44.2969H434.125V45.75H457.375V44.2969ZM457.375 45.75H434.125V47.2031H457.375V45.75ZM445.75 47.2031H434.125V48.6562H445.75V47.2031Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 47.2031H445.75V48.6562H451.562V47.2031Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.375 47.2031H451.562V48.6562H457.375V47.2031ZM445.75 48.6562H434.125V50.1094H445.75V48.6562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 48.6562H445.75V50.1095H454.469V48.6562Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.375 48.6562H454.469V50.1095H457.375V48.6562ZM445.75 50.1095H434.125V51.5625H445.75V50.1095Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 50.1094H445.75V51.5625H451.562V50.1094Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.375 50.1094H451.562V51.5625H457.375V50.1094ZM445.75 51.5625H434.125V53.0156H445.75V51.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 51.5625H445.75V53.0156H451.562V51.5625Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.375 51.5625H451.562V53.0156H457.375V51.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75 38.4844H437.031V39.9375H445.75V38.4844ZM455.922 38.4844H447.203V39.9375H455.922V38.4844ZM438.484 39.9375H437.031V41.3906H438.484V39.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.391 39.9375H438.484V41.3906H441.391V39.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.297 39.9375H441.391V41.3906H444.297V39.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75 39.9375H444.297V41.3906H445.75V39.9375ZM448.656 39.9375H447.203V41.3906H448.656V39.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 39.9375H448.656V41.3906H451.562V39.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 39.9375H451.562V41.3906H454.469V39.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 39.9375H454.469V41.3906H455.922V39.9375ZM438.484 41.3906H432.672V42.8438H438.484V41.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.391 41.3906H438.484V42.8438H441.391V41.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.297 41.3906H441.391V42.8438H444.297V41.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.656 41.3906H444.297V42.8438H448.656V41.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 41.3906H448.656V42.8438H451.562V41.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 41.3906H451.562V42.8438H454.469V41.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 41.3906H454.469V42.8438H455.922V41.3906ZM434.125 42.8438H432.672V44.2969H434.125V42.8438ZM438.484 42.8438H437.031V44.2969H438.484V42.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.391 42.8438H438.484V44.2969H441.391V42.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.297 42.8438H441.391V44.2969H444.297V42.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75 42.8438H444.297V44.2969H445.75V42.8438ZM448.656 42.8438H447.203V44.2969H448.656V42.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 42.8438H448.656V44.2969H451.562V42.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 42.8438H451.562V44.2969H454.469V42.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 42.8438H454.469V44.2969H455.922V42.8438ZM434.125 44.2969H432.672V45.75H434.125V44.2969ZM438.484 44.2969H437.031V45.75H438.484V44.2969Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.391 44.2969H438.484V45.75H441.391V44.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.297 44.2969H441.391V45.75H444.297V44.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75 44.2969H444.297V45.75H445.75V44.2969ZM448.656 44.2969H447.203V45.75H448.656V44.2969Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.562 44.2969H448.656V45.75H451.562V44.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.469 44.2969H451.562V45.75H454.469V44.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.922 44.2969H454.469V45.75H455.922V44.2969ZM445.75 45.75H437.031V47.2031H445.75V45.75ZM455.922 45.75H447.203V47.2031H455.922V45.75Z",
    fill: "#F3322C"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.75 102.5C257.733 102.5 271.5 88.7328 271.5 71.75C271.5 54.7672 257.733 41 240.75 41C223.767 41 210 54.7672 210 71.75C210 88.7328 223.767 102.5 240.75 102.5Z",
    fill: "#479E64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 48,
    width: 47,
    height: 47
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264 71.75C264 58.9094 253.591 48.5 240.75 48.5C227.909 48.5 217.5 58.9094 217.5 71.75C217.5 84.5906 227.909 95 240.75 95C253.591 95 264 84.5906 264 71.75Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.5 48.5H264V95H217.5V48.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.645 48.5H217.5V48.6453H217.645V48.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 79.0156H230.578V80.4688H250.922V79.0156ZM250.922 80.4688H230.578V81.9219H250.922V80.4688ZM250.922 81.9219H230.578V83.375H250.922V81.9219ZM250.922 83.375H230.578V84.8281H250.922V83.375ZM233.484 84.8281H230.578V86.2812H233.484V84.8281ZM250.922 84.8281H234.938V86.2812H250.922V84.8281ZM233.484 86.2812H230.578V87.7344H233.484V86.2812ZM250.922 86.2812H234.938V87.7344H250.922V86.2812ZM233.484 87.7344H230.578V89.1875H233.484V87.7344ZM250.922 87.7344H234.938V89.1875H250.922V87.7344ZM233.484 89.1875H230.578V90.6406H233.484V89.1875ZM250.922 89.1875H234.938V90.6406H250.922V89.1875ZM233.484 90.6406H230.578V92.0938H233.484V90.6406ZM250.922 90.6406H234.938V92.0938H250.922V90.6406ZM233.484 92.0938H230.578V93.5469H233.484V92.0938ZM250.922 92.0938H234.938V93.5469H250.922V92.0938ZM233.484 93.5469H230.578V95H233.484V93.5469ZM250.922 93.5469H234.938V95H250.922V93.5469Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 83.375H243.656V84.8281H245.109V83.375ZM242.203 84.8281H237.844V86.2812H242.203V84.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.656 84.8281H242.203V86.2812H243.656V84.8281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 84.8281H243.656V86.2812H245.109V84.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 84.8281H245.109V86.2812H246.562V84.8281Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.844 86.2812H236.391V87.7345H237.844V86.2812ZM240.75 86.2812H239.297V87.7345H240.75V86.2812Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.203 86.2812H240.75V87.7345H242.203V86.2812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 86.2812H242.203V87.7345H245.109V86.2812ZM237.844 87.7345H236.391V89.1876H237.844V87.7345ZM240.75 87.7345H239.297V89.1876H240.75V87.7345Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.656 87.7344H240.75V89.1875H243.656V87.7344Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 87.7344H243.656V89.1875H245.109V87.7344ZM240.75 89.1875H239.297V90.6406H240.75V89.1875ZM245.109 89.1875H243.656V90.6406H245.109V89.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.844 52.8594H236.391V54.3125H237.844V52.8594ZM243.656 52.8594H239.297V54.3125H243.656V52.8594ZM245.109 54.3125H234.938V55.7656H245.109V54.3125ZM245.109 55.7656H233.484V57.2188H245.109V55.7656Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.938 57.2188H232.031V58.6719H234.938V57.2188Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 57.2188H234.938V58.6719H245.109V57.2188Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 57.2188H245.109V58.6719H249.469V57.2188ZM239.297 58.6719H230.578V60.125H239.297V58.6719Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 58.6719H239.297V60.125H245.109V58.6719Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 58.6719H245.109V60.125H250.922V58.6719ZM243.656 60.125H230.578V61.5781H243.656V60.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.109 60.125H243.656V61.5781H245.109V60.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 60.125H245.109V61.5781H250.922V60.125ZM252.375 61.5781H229.125V63.0312H252.375V61.5781ZM252.375 63.0312H229.125V64.4844H252.375V63.0312ZM252.375 64.4844H229.125V65.9375H252.375V64.4844ZM252.375 65.9375H229.125V67.3906H252.375V65.9375ZM252.375 67.3906H229.125V68.8438H252.375V67.3906ZM252.375 68.8438H229.125V70.2969H252.375V68.8438ZM252.375 70.2969H229.125V71.75H252.375V70.2969ZM252.375 71.75H229.125V73.2031H252.375V71.75ZM240.75 73.2031H229.125V74.6562H240.75V73.2031Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 73.2031H240.75V74.6562H246.562V73.2031Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.375 73.2031H246.562V74.6562H252.375V73.2031ZM240.75 74.6562H229.125V76.1094H240.75V74.6562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 74.6562H240.75V76.1095H249.469V74.6562Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.375 74.6562H249.469V76.1095H252.375V74.6562ZM240.75 76.1095H229.125V77.5626H240.75V76.1095Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 76.1094H240.75V77.5625H246.562V76.1094Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.375 76.1094H246.562V77.5625H252.375V76.1094ZM240.75 77.5625H229.125V79.0156H240.75V77.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 77.5625H240.75V79.0156H246.562V77.5625Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.375 77.5625H246.562V79.0156H252.375V77.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 64.4844H232.031V65.9375H240.75V64.4844ZM250.922 64.4844H242.203V65.9375H250.922V64.4844ZM233.484 65.9375H232.031V67.3906H233.484V65.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.391 65.9375H233.484V67.3906H236.391V65.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.297 65.9375H236.391V67.3906H239.297V65.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 65.9375H239.297V67.3906H240.75V65.9375ZM243.656 65.9375H242.203V67.3906H243.656V65.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 65.9375H243.656V67.3906H246.562V65.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 65.9375H246.562V67.3906H249.469V65.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 65.9375H249.469V67.3906H250.922V65.9375ZM233.484 67.3906H227.672V68.8438H233.484V67.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.391 67.3906H233.484V68.8438H236.391V67.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.297 67.3906H236.391V68.8438H239.297V67.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.656 67.3906H239.297V68.8438H243.656V67.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 67.3906H243.656V68.8438H246.562V67.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 67.3906H246.562V68.8438H249.469V67.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 67.3906H249.469V68.8438H250.922V67.3906ZM229.125 68.8438H227.672V70.2969H229.125V68.8438ZM233.484 68.8438H232.031V70.2969H233.484V68.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.391 68.8438H233.484V70.2968H236.391V68.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.297 68.8438H236.391V70.2968H239.297V68.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 68.8438H239.297V70.2968H240.75V68.8438ZM243.656 68.8438H242.203V70.2968H243.656V68.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 68.8438H243.656V70.2968H246.562V68.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 68.8438H246.562V70.2968H249.469V68.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 68.8438H249.469V70.2968H250.922V68.8438ZM229.125 70.2968H227.672V71.7499H229.125V70.2968ZM233.484 70.2968H232.031V71.7499H233.484V70.2968Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.391 70.2969H233.484V71.75H236.391V70.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.297 70.2969H236.391V71.75H239.297V70.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 70.2969H239.297V71.75H240.75V70.2969ZM243.656 70.2969H242.203V71.75H243.656V70.2969Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.562 70.2969H243.656V71.75H246.562V70.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.469 70.2969H246.562V71.75H249.469V70.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.922 70.2969H249.469V71.75H250.922V70.2969ZM240.75 71.75H232.031V73.2031H240.75V71.75ZM250.922 71.75H242.203V73.2031H250.922V71.75Z",
    fill: "#F3322C"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.75 206.5C62.7328 206.5 76.5 192.733 76.5 175.75C76.5 158.767 62.7328 145 45.75 145C28.7672 145 15 158.767 15 175.75C15 192.733 28.7672 206.5 45.75 206.5Z",
    fill: "#D7AD3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 152,
    width: 47,
    height: 47
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69 175.75C69 162.909 58.5906 152.5 45.75 152.5C32.9094 152.5 22.5 162.909 22.5 175.75C22.5 188.591 32.9094 199 45.75 199C58.5906 199 69 188.591 69 175.75Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 152.5H69V199H22.5V152.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6453 152.5H22.5V152.645H22.6453V152.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 183.016H35.5781V184.469H55.9219V183.016ZM55.9219 184.469H35.5781V185.922H55.9219V184.469ZM55.9219 185.922H35.5781V187.375H55.9219V185.922ZM55.9219 187.375H35.5781V188.828H55.9219V187.375ZM38.4844 188.828H35.5781V190.281H38.4844V188.828ZM55.9219 188.828H39.9375V190.281H55.9219V188.828ZM38.4844 190.281H35.5781V191.734H38.4844V190.281ZM55.9219 190.281H39.9375V191.734H55.9219V190.281ZM38.4844 191.734H35.5781V193.188H38.4844V191.734ZM55.9219 191.734H39.9375V193.188H55.9219V191.734ZM38.4844 193.188H35.5781V194.641H38.4844V193.188ZM55.9219 193.188H39.9375V194.641H55.9219V193.188ZM38.4844 194.641H35.5781V196.094H38.4844V194.641ZM55.9219 194.641H39.9375V196.094H55.9219V194.641ZM38.4844 196.094H35.5781V197.547H38.4844V196.094ZM55.9219 196.094H39.9375V197.547H55.9219V196.094ZM38.4844 197.547H35.5781V199H38.4844V197.547ZM55.9219 197.547H39.9375V199H55.9219V197.547Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 187.375H48.6562V188.828H50.1094V187.375ZM47.203 188.828H42.8438V190.281H47.203V188.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6562 188.828H47.2031V190.281H48.6562V188.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1095 188.828H48.6562V190.281H50.1095V188.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 188.828H50.1094V190.281H51.5625V188.828Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8438 190.281H41.3906V191.734H42.8438V190.281ZM45.75 190.281H44.2969V191.734H45.75V190.281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2031 190.281H45.75V191.734H47.2031V190.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 190.281H47.2031V191.734H50.1094V190.281ZM42.8438 191.734H41.3906V193.188H42.8438V191.734ZM45.75 191.734H44.2969V193.188H45.75V191.734Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6562 191.734H45.75V193.188H48.6562V191.734Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 191.734H48.6562V193.188H50.1094V191.734ZM45.75 193.188H44.2969V194.641H45.75V193.188ZM50.1094 193.188H48.6562V194.641H50.1094V193.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8438 156.859H41.3906V158.312H42.8438V156.859ZM48.6562 156.859H44.2969V158.312H48.6562V156.859ZM50.1094 158.312H39.9375V159.766H50.1094V158.312ZM50.1094 159.766H38.4844V161.219H50.1094V159.766Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 161.219H37.0312V162.672H39.9375V161.219Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 161.219H39.9375V162.672H50.1094V161.219Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 161.219H50.1094V162.672H54.4688V161.219ZM44.2969 162.672H35.5781V164.125H44.2969V162.672Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 162.672H44.2969V164.125H50.1094V162.672Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 162.672H50.1094V164.125H55.9219V162.672ZM48.6562 164.125H35.5781V165.578H48.6562V164.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1095 164.125H48.6562V165.578H50.1095V164.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 164.125H50.1094V165.578H55.9219V164.125ZM57.375 165.578H34.125V167.031H57.375V165.578ZM57.375 167.031H34.125V168.484H57.375V167.031ZM57.375 168.484H34.125V169.938H57.375V168.484ZM57.375 169.938H34.125V171.391H57.375V169.938ZM57.375 171.391H34.125V172.844H57.375V171.391ZM57.375 172.844H34.125V174.297H57.375V172.844ZM57.375 174.297H34.125V175.75H57.375V174.297ZM57.375 175.75H34.125V177.203H57.375V175.75ZM45.75 177.203H34.125V178.656H45.75V177.203Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 177.203H45.75V178.656H51.5625V177.203Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.375 177.203H51.5625V178.656H57.375V177.203ZM45.75 178.656H34.125V180.109H45.75V178.656Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 178.656H45.75V180.109H54.4688V178.656Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.375 178.656H54.4688V180.109H57.375V178.656ZM45.75 180.109H34.125V181.562H45.75V180.109Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 180.109H45.75V181.562H51.5625V180.109Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.375 180.109H51.5625V181.562H57.375V180.109ZM45.75 181.562H34.125V183.016H45.75V181.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 181.562H45.75V183.016H51.5625V181.562Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.375 181.562H51.5625V183.016H57.375V181.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75 168.484H37.0312V169.938H45.75V168.484ZM55.922 168.484H47.2031V169.938H55.922V168.484ZM38.4845 169.938H37.0312V171.391H38.4845V169.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3906 169.938H38.4844V171.391H41.3906V169.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2969 169.938H41.3906V171.391H44.2969V169.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75 169.938H44.2969V171.391H45.75V169.938ZM48.6562 169.938H47.2031V171.391H48.6562V169.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 169.938H48.6562V171.391H51.5625V169.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 169.938H51.5625V171.391H54.4688V169.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 169.938H54.4688V171.391H55.9219V169.938ZM38.4844 171.391H32.6719V172.844H38.4844V171.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3906 171.391H38.4844V172.844H41.3906V171.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2969 171.391H41.3906V172.844H44.2969V171.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6562 171.391H44.2969V172.844H48.6562V171.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 171.391H48.6562V172.844H51.5625V171.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 171.391H51.5625V172.844H54.4688V171.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 171.391H54.4688V172.844H55.9219V171.391ZM34.125 172.844H32.6719V174.297H34.125V172.844ZM38.4844 172.844H37.0312V174.297H38.4844V172.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3906 172.844H38.4844V174.297H41.3906V172.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2969 172.844H41.3906V174.297H44.2969V172.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75 172.844H44.2969V174.297H45.75V172.844ZM48.6562 172.844H47.2031V174.297H48.6562V172.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 172.844H48.6562V174.297H51.5625V172.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 172.844H51.5625V174.297H54.4688V172.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 172.844H54.4688V174.297H55.9219V172.844ZM34.125 174.297H32.6719V175.75H34.125V174.297ZM38.4844 174.297H37.0312V175.75H38.4844V174.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3906 174.297H38.4844V175.75H41.3906V174.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2969 174.297H41.3906V175.75H44.2969V174.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75 174.297H44.2969V175.75H45.75V174.297ZM48.6562 174.297H47.2031V175.75H48.6562V174.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 174.297H48.6562V175.75H51.5625V174.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4688 174.297H51.5625V175.75H54.4688V174.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.922 174.297H54.4688V175.75H55.922V174.297ZM45.75 175.75H37.0312V177.203H45.75V175.75ZM55.922 175.75H47.2031V177.203H55.922V175.75Z",
    fill: "#F3322C"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.75 508.5C124.733 508.5 138.5 494.733 138.5 477.75C138.5 460.767 124.733 447 107.75 447C90.7672 447 77 460.767 77 477.75C77 494.733 90.7672 508.5 107.75 508.5Z",
    fill: "#333333"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.75 508.5C124.733 508.5 138.5 494.733 138.5 477.75C138.5 460.767 124.733 447 107.75 447C90.7672 447 77 460.767 77 477.75C77 494.733 90.7672 508.5 107.75 508.5Z",
    fill: "#C63B32"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 454,
    width: 47,
    height: 47
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131 477.75C131 464.909 120.591 454.5 107.75 454.5C94.9094 454.5 84.5 464.909 84.5 477.75C84.5 490.591 94.9094 501 107.75 501C120.591 501 131 490.591 131 477.75Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 454.5H131V501H84.5V454.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6453 454.5H84.5V454.645H84.6453V454.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 485.016H97.5781V486.469H117.922V485.016ZM117.922 486.469H97.5781V487.922H117.922V486.469ZM117.922 487.922H97.5781V489.375H117.922V487.922ZM117.922 489.375H97.5781V490.828H117.922V489.375ZM100.484 490.828H97.5781V492.281H100.484V490.828ZM117.922 490.828H101.938V492.281H117.922V490.828ZM100.484 492.281H97.5781V493.734H100.484V492.281ZM117.922 492.281H101.938V493.734H117.922V492.281ZM100.484 493.734H97.5781V495.188H100.484V493.734ZM117.922 493.734H101.938V495.188H117.922V493.734ZM100.484 495.188H97.5781V496.641H100.484V495.188ZM117.922 495.188H101.938V496.641H117.922V495.188ZM100.484 496.641H97.5781V498.094H100.484V496.641ZM117.922 496.641H101.938V498.094H117.922V496.641ZM100.484 498.094H97.5781V499.547H100.484V498.094ZM117.922 498.094H101.938V499.547H117.922V498.094ZM100.484 499.547H97.5781V501H100.484V499.547ZM117.922 499.547H101.938V501H117.922V499.547Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 489.375H110.656V490.828H112.109V489.375ZM109.203 490.828H104.844V492.281H109.203V490.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.656 490.828H109.203V492.281H110.656V490.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 490.828H110.656V492.281H112.109V490.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 490.828H112.109V492.281H113.562V490.828Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.844 492.281H103.391V493.734H104.844V492.281ZM107.75 492.281H106.297V493.734H107.75V492.281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 492.281H107.75V493.734H109.203V492.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 492.281H109.203V493.734H112.109V492.281ZM104.844 493.734H103.391V495.188H104.844V493.734ZM107.75 493.734H106.297V495.188H107.75V493.734Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.656 493.734H107.75V495.188H110.656V493.734Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 493.734H110.656V495.188H112.109V493.734ZM107.75 495.188H106.297V496.641H107.75V495.188ZM112.109 495.188H110.656V496.641H112.109V495.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.844 458.859H103.391V460.312H104.844V458.859ZM110.656 458.859H106.297V460.312H110.656V458.859ZM112.109 460.312H101.938V461.766H112.109V460.312ZM112.109 461.766H100.484V463.219H112.109V461.766Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.938 463.219H99.0312V464.672H101.938V463.219Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 463.219H101.938V464.672H112.109V463.219Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 463.219H112.109V464.672H116.469V463.219ZM106.297 464.672H97.5781V466.125H106.297V464.672Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 464.672H106.297V466.125H112.109V464.672Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 464.672H112.109V466.125H117.922V464.672ZM110.656 466.125H97.5781V467.578H110.656V466.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 466.125H110.656V467.578H112.109V466.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 466.125H112.109V467.578H117.922V466.125ZM119.375 467.578H96.125V469.031H119.375V467.578ZM119.375 469.031H96.125V470.484H119.375V469.031ZM119.375 470.484H96.125V471.938H119.375V470.484ZM119.375 471.938H96.125V473.391H119.375V471.938ZM119.375 473.391H96.125V474.844H119.375V473.391ZM119.375 474.844H96.125V476.297H119.375V474.844ZM119.375 476.297H96.125V477.75H119.375V476.297ZM119.375 477.75H96.125V479.203H119.375V477.75ZM107.75 479.203H96.125V480.656H107.75V479.203Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 479.203H107.75V480.656H113.562V479.203Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.375 479.203H113.562V480.656H119.375V479.203ZM107.75 480.656H96.125V482.109H107.75V480.656Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 480.656H107.75V482.109H116.469V480.656Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.375 480.656H116.469V482.109H119.375V480.656ZM107.75 482.109H96.125V483.562H107.75V482.109Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 482.109H107.75V483.562H113.562V482.109Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.375 482.109H113.562V483.562H119.375V482.109ZM107.75 483.562H96.125V485.016H107.75V483.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 483.562H107.75V485.016H113.562V483.562Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.375 483.562H113.562V485.016H119.375V483.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 470.484H99.0312V471.938H107.75V470.484ZM117.922 470.484H109.203V471.938H117.922V470.484ZM100.484 471.938H99.0312V473.391H100.484V471.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.391 471.938H100.484V473.391H103.391V471.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.297 471.938H103.391V473.391H106.297V471.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 471.938H106.297V473.391H107.75V471.938ZM110.656 471.938H109.203V473.391H110.656V471.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 471.938H110.656V473.391H113.562V471.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 471.938H113.562V473.391H116.469V471.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 471.938H116.469V473.391H117.922V471.938ZM100.484 473.391H94.6719V474.844H100.484V473.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.391 473.391H100.484V474.844H103.391V473.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.297 473.391H103.391V474.844H106.297V473.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.656 473.391H106.297V474.844H110.656V473.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 473.391H110.656V474.844H113.562V473.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 473.391H113.562V474.844H116.469V473.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 473.391H116.469V474.844H117.922V473.391ZM96.125 474.844H94.6719V476.297H96.125V474.844ZM100.484 474.844H99.0312V476.297H100.484V474.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.391 474.844H100.484V476.297H103.391V474.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.297 474.844H103.391V476.297H106.297V474.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 474.844H106.297V476.297H107.75V474.844ZM110.656 474.844H109.203V476.297H110.656V474.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 474.844H110.656V476.297H113.562V474.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 474.844H113.562V476.297H116.469V474.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 474.844H116.469V476.297H117.922V474.844ZM96.125 476.297H94.6719V477.75H96.125V476.297ZM100.484 476.297H99.0312V477.75H100.484V476.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.391 476.297H100.484V477.75H103.391V476.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.297 476.297H103.391V477.75H106.297V476.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 476.297H106.297V477.75H107.75V476.297ZM110.656 476.297H109.203V477.75H110.656V476.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.562 476.297H110.656V477.75H113.562V476.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.469 476.297H113.562V477.75H116.469V476.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.922 476.297H116.469V477.75H117.922V476.297ZM107.75 477.75H99.0312V479.203H107.75V477.75ZM117.922 477.75H109.203V479.203H117.922V477.75Z",
    fill: "#F3322C"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.75 78.5C661.733 78.5 675.5 64.7328 675.5 47.75C675.5 30.7672 661.733 17 644.75 17C627.767 17 614 30.7672 614 47.75C614 64.7328 627.767 78.5 644.75 78.5Z",
    fill: "#C63B32"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 621,
    y: 24,
    width: 47,
    height: 47
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M668 47.75C668 34.9094 657.591 24.5 644.75 24.5C631.909 24.5 621.5 34.9094 621.5 47.75C621.5 60.5906 631.909 71 644.75 71C657.591 71 668 60.5906 668 47.75Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.5 24.5H668V71H621.5V24.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.645 24.5H621.5V24.6453H621.645V24.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 55.0156H634.578V56.4688H654.922V55.0156ZM654.922 56.4688H634.578V57.9219H654.922V56.4688ZM654.922 57.9219H634.578V59.375H654.922V57.9219ZM654.922 59.375H634.578V60.8281H654.922V59.375ZM637.484 60.8281H634.578V62.2812H637.484V60.8281ZM654.922 60.8281H638.938V62.2812H654.922V60.8281ZM637.484 62.2812H634.578V63.7344H637.484V62.2812ZM654.922 62.2812H638.938V63.7344H654.922V62.2812ZM637.484 63.7344H634.578V65.1875H637.484V63.7344ZM654.922 63.7344H638.938V65.1875H654.922V63.7344ZM637.484 65.1875H634.578V66.6406H637.484V65.1875ZM654.922 65.1875H638.938V66.6406H654.922V65.1875ZM637.484 66.6406H634.578V68.0938H637.484V66.6406ZM654.922 66.6406H638.938V68.0938H654.922V66.6406ZM637.484 68.0938H634.578V69.5469H637.484V68.0938ZM654.922 68.0938H638.938V69.5469H654.922V68.0938ZM637.484 69.5469H634.578V71H637.484V69.5469ZM654.922 69.5469H638.938V71H654.922V69.5469Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 59.375H647.656V60.8281H649.109V59.375ZM646.203 60.8281H641.844V62.2812H646.203V60.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.656 60.8281H646.203V62.2812H647.656V60.8281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 60.8281H647.656V62.2812H649.109V60.8281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 60.8281H649.109V62.2812H650.562V60.8281Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.844 62.2812H640.391V63.7345H641.844V62.2812ZM644.75 62.2812H643.297V63.7345H644.75V62.2812Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.203 62.2812H644.75V63.7345H646.203V62.2812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 62.2812H646.203V63.7345H649.109V62.2812ZM641.844 63.7345H640.391V65.1875H641.844V63.7345ZM644.75 63.7345H643.297V65.1875H644.75V63.7345Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.656 63.7344H644.75V65.1875H647.656V63.7344Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 63.7344H647.656V65.1875H649.109V63.7344ZM644.75 65.1875H643.297V66.6406H644.75V65.1875ZM649.109 65.1875H647.656V66.6406H649.109V65.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.844 28.8594H640.391V30.3125H641.844V28.8594ZM647.656 28.8594H643.297V30.3125H647.656V28.8594ZM649.109 30.3125H638.938V31.7656H649.109V30.3125ZM649.109 31.7656H637.484V33.2188H649.109V31.7656Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.938 33.2188H636.031V34.6719H638.938V33.2188Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 33.2188H638.938V34.6719H649.109V33.2188Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 33.2188H649.109V34.6719H653.469V33.2188ZM643.297 34.6719H634.578V36.125H643.297V34.6719Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 34.6719H643.297V36.125H649.109V34.6719Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 34.6719H649.109V36.125H654.922V34.6719ZM647.656 36.125H634.578V37.5781H647.656V36.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.109 36.125H647.656V37.5781H649.109V36.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 36.125H649.109V37.5781H654.922V36.125ZM656.375 37.5781H633.125V39.0312H656.375V37.5781ZM656.375 39.0312H633.125V40.4844H656.375V39.0312ZM656.375 40.4844H633.125V41.9375H656.375V40.4844ZM656.375 41.9375H633.125V43.3906H656.375V41.9375ZM656.375 43.3906H633.125V44.8438H656.375V43.3906ZM656.375 44.8438H633.125V46.2969H656.375V44.8438ZM656.375 46.2969H633.125V47.75H656.375V46.2969ZM656.375 47.75H633.125V49.2031H656.375V47.75ZM644.75 49.2031H633.125V50.6562H644.75V49.2031Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 49.2031H644.75V50.6562H650.562V49.2031Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.375 49.2031H650.562V50.6562H656.375V49.2031ZM644.75 50.6562H633.125V52.1094H644.75V50.6562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 50.6562H644.75V52.1095H653.469V50.6562Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.375 50.6562H653.469V52.1095H656.375V50.6562ZM644.75 52.1095H633.125V53.5625H644.75V52.1095Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 52.1094H644.75V53.5625H650.562V52.1094Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.375 52.1094H650.562V53.5625H656.375V52.1094ZM644.75 53.5625H633.125V55.0156H644.75V53.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 53.5625H644.75V55.0156H650.562V53.5625Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.375 53.5625H650.562V55.0156H656.375V53.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.75 40.4844H636.031V41.9375H644.75V40.4844ZM654.922 40.4844H646.203V41.9375H654.922V40.4844ZM637.484 41.9375H636.031V43.3906H637.484V41.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.391 41.9375H637.484V43.3906H640.391V41.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.297 41.9375H640.391V43.3906H643.297V41.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.75 41.9375H643.297V43.3906H644.75V41.9375ZM647.656 41.9375H646.203V43.3906H647.656V41.9375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 41.9375H647.656V43.3906H650.562V41.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 41.9375H650.562V43.3906H653.469V41.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 41.9375H653.469V43.3906H654.922V41.9375ZM637.484 43.3906H631.672V44.8438H637.484V43.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.391 43.3906H637.484V44.8438H640.391V43.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.297 43.3906H640.391V44.8438H643.297V43.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.656 43.3906H643.297V44.8438H647.656V43.3906Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 43.3906H647.656V44.8438H650.562V43.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 43.3906H650.562V44.8438H653.469V43.3906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 43.3906H653.469V44.8438H654.922V43.3906ZM633.125 44.8438H631.672V46.2969H633.125V44.8438ZM637.484 44.8438H636.031V46.2969H637.484V44.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.391 44.8438H637.484V46.2969H640.391V44.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.297 44.8438H640.391V46.2969H643.297V44.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.75 44.8438H643.297V46.2969H644.75V44.8438ZM647.656 44.8438H646.203V46.2969H647.656V44.8438Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 44.8438H647.656V46.2969H650.562V44.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 44.8438H650.562V46.2969H653.469V44.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 44.8438H653.469V46.2969H654.922V44.8438ZM633.125 46.2969H631.672V47.75H633.125V46.2969ZM637.484 46.2969H636.031V47.75H637.484V46.2969Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.391 46.2969H637.484V47.75H640.391V46.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.297 46.2969H640.391V47.75H643.297V46.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.75 46.2969H643.297V47.75H644.75V46.2969ZM647.656 46.2969H646.203V47.75H647.656V46.2969Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.562 46.2969H647.656V47.75H650.562V46.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.469 46.2969H650.562V47.75H653.469V46.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.922 46.2969H653.469V47.75H654.922V46.2969ZM644.75 47.75H636.031V49.2031H644.75V47.75ZM654.922 47.75H646.203V49.2031H654.922V47.75Z",
    fill: "#F3322C"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M776.75 240.5C793.733 240.5 807.5 226.733 807.5 209.75C807.5 192.767 793.733 179 776.75 179C759.767 179 746 192.767 746 209.75C746 226.733 759.767 240.5 776.75 240.5Z",
    fill: "#A45D81"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 753,
    y: 186,
    width: 47,
    height: 47
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M800 209.75C800 196.909 789.591 186.5 776.75 186.5C763.909 186.5 753.5 196.909 753.5 209.75C753.5 222.591 763.909 233 776.75 233C789.591 233 800 222.591 800 209.75Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M753.5 186.5H800V233H753.5V186.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.645 186.5H753.5V186.645H753.645V186.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 217.016H766.578V218.469H786.922V217.016ZM786.922 218.469H766.578V219.922H786.922V218.469ZM786.922 219.922H766.578V221.375H786.922V219.922ZM786.922 221.375H766.578V222.828H786.922V221.375ZM769.484 222.828H766.578V224.281H769.484V222.828ZM786.922 222.828H770.938V224.281H786.922V222.828ZM769.484 224.281H766.578V225.734H769.484V224.281ZM786.922 224.281H770.938V225.734H786.922V224.281ZM769.484 225.734H766.578V227.188H769.484V225.734ZM786.922 225.734H770.938V227.188H786.922V225.734ZM769.484 227.188H766.578V228.641H769.484V227.188ZM786.922 227.188H770.938V228.641H786.922V227.188ZM769.484 228.641H766.578V230.094H769.484V228.641ZM786.922 228.641H770.938V230.094H786.922V228.641ZM769.484 230.094H766.578V231.547H769.484V230.094ZM786.922 230.094H770.938V231.547H786.922V230.094ZM769.484 231.547H766.578V233H769.484V231.547ZM786.922 231.547H770.938V233H786.922V231.547Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 221.375H779.656V222.828H781.109V221.375ZM778.203 222.828H773.844V224.281H778.203V222.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.656 222.828H778.203V224.281H779.656V222.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 222.828H779.656V224.281H781.109V222.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 222.828H781.109V224.281H782.562V222.828Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.844 224.281H772.391V225.734H773.844V224.281ZM776.75 224.281H775.297V225.734H776.75V224.281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.203 224.281H776.75V225.734H778.203V224.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 224.281H778.203V225.734H781.109V224.281ZM773.844 225.734H772.391V227.188H773.844V225.734ZM776.75 225.734H775.297V227.188H776.75V225.734Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.656 225.734H776.75V227.188H779.656V225.734Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 225.734H779.656V227.188H781.109V225.734ZM776.75 227.188H775.297V228.641H776.75V227.188ZM781.109 227.188H779.656V228.641H781.109V227.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.844 190.859H772.391V192.312H773.844V190.859ZM779.656 190.859H775.297V192.312H779.656V190.859ZM781.109 192.312H770.938V193.766H781.109V192.312ZM781.109 193.766H769.484V195.219H781.109V193.766Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.938 195.219H768.031V196.672H770.938V195.219Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 195.219H770.938V196.672H781.109V195.219Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 195.219H781.109V196.672H785.469V195.219ZM775.297 196.672H766.578V198.125H775.297V196.672Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 196.672H775.297V198.125H781.109V196.672Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 196.672H781.109V198.125H786.922V196.672ZM779.656 198.125H766.578V199.578H779.656V198.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.109 198.125H779.656V199.578H781.109V198.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 198.125H781.109V199.578H786.922V198.125ZM788.375 199.578H765.125V201.031H788.375V199.578ZM788.375 201.031H765.125V202.484H788.375V201.031ZM788.375 202.484H765.125V203.938H788.375V202.484ZM788.375 203.938H765.125V205.391H788.375V203.938ZM788.375 205.391H765.125V206.844H788.375V205.391ZM788.375 206.844H765.125V208.297H788.375V206.844ZM788.375 208.297H765.125V209.75H788.375V208.297ZM788.375 209.75H765.125V211.203H788.375V209.75ZM776.75 211.203H765.125V212.656H776.75V211.203Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 211.203H776.75V212.656H782.562V211.203Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.375 211.203H782.562V212.656H788.375V211.203ZM776.75 212.656H765.125V214.109H776.75V212.656Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 212.656H776.75V214.109H785.469V212.656Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.375 212.656H785.469V214.109H788.375V212.656ZM776.75 214.109H765.125V215.562H776.75V214.109Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 214.109H776.75V215.562H782.562V214.109Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.375 214.109H782.562V215.562H788.375V214.109ZM776.75 215.562H765.125V217.016H776.75V215.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 215.562H776.75V217.016H782.562V215.562Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.375 215.562H782.562V217.016H788.375V215.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.75 202.484H768.031V203.938H776.75V202.484ZM786.922 202.484H778.203V203.938H786.922V202.484ZM769.484 203.938H768.031V205.391H769.484V203.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.391 203.938H769.484V205.391H772.391V203.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.297 203.938H772.391V205.391H775.297V203.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.75 203.938H775.297V205.391H776.75V203.938ZM779.656 203.938H778.203V205.391H779.656V203.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 203.938H779.656V205.391H782.562V203.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 203.938H782.562V205.391H785.469V203.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 203.938H785.469V205.391H786.922V203.938ZM769.484 205.391H763.672V206.844H769.484V205.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.391 205.391H769.484V206.844H772.391V205.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.297 205.391H772.391V206.844H775.297V205.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.656 205.391H775.297V206.844H779.656V205.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 205.391H779.656V206.844H782.562V205.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 205.391H782.562V206.844H785.469V205.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 205.391H785.469V206.844H786.922V205.391ZM765.125 206.844H763.672V208.297H765.125V206.844ZM769.484 206.844H768.031V208.297H769.484V206.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.391 206.844H769.484V208.297H772.391V206.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.297 206.844H772.391V208.297H775.297V206.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.75 206.844H775.297V208.297H776.75V206.844ZM779.656 206.844H778.203V208.297H779.656V206.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 206.844H779.656V208.297H782.562V206.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 206.844H782.562V208.297H785.469V206.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 206.844H785.469V208.297H786.922V206.844ZM765.125 208.297H763.672V209.75H765.125V208.297ZM769.484 208.297H768.031V209.75H769.484V208.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.391 208.297H769.484V209.75H772.391V208.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.297 208.297H772.391V209.75H775.297V208.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.75 208.297H775.297V209.75H776.75V208.297ZM779.656 208.297H778.203V209.75H779.656V208.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.562 208.297H779.656V209.75H782.562V208.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.469 208.297H782.562V209.75H785.469V208.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.922 208.297H785.469V209.75H786.922V208.297ZM776.75 209.75H768.031V211.203H776.75V209.75ZM786.922 209.75H778.203V211.203H786.922V209.75Z",
    fill: "#F3322C"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.25 504.5C790.233 504.5 804 490.733 804 473.75C804 456.767 790.233 443 773.25 443C756.267 443 742.5 456.767 742.5 473.75C742.5 490.733 756.267 504.5 773.25 504.5Z",
    fill: "#479E64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_230_1751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 750,
    y: 450,
    width: 47,
    height: 47
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M796.5 473.75C796.5 460.909 786.091 450.5 773.25 450.5C760.409 450.5 750 460.909 750 473.75C750 486.591 760.409 497 773.25 497C786.091 497 796.5 486.591 796.5 473.75Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_230_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750 450.5H796.5V497H750V450.5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.145 450.5H750V450.645H750.145V450.5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 481.016H763.078V482.469H783.422V481.016ZM783.422 482.469H763.078V483.922H783.422V482.469ZM783.422 483.922H763.078V485.375H783.422V483.922ZM783.422 485.375H763.078V486.828H783.422V485.375ZM765.984 486.828H763.078V488.281H765.984V486.828ZM783.422 486.828H767.438V488.281H783.422V486.828ZM765.984 488.281H763.078V489.734H765.984V488.281ZM783.422 488.281H767.438V489.734H783.422V488.281ZM765.984 489.734H763.078V491.188H765.984V489.734ZM783.422 489.734H767.438V491.188H783.422V489.734ZM765.984 491.188H763.078V492.641H765.984V491.188ZM783.422 491.188H767.438V492.641H783.422V491.188ZM765.984 492.641H763.078V494.094H765.984V492.641ZM783.422 492.641H767.438V494.094H783.422V492.641ZM765.984 494.094H763.078V495.547H765.984V494.094ZM783.422 494.094H767.438V495.547H783.422V494.094ZM765.984 495.547H763.078V497H765.984V495.547ZM783.422 495.547H767.438V497H783.422V495.547Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 485.375H776.156V486.828H777.609V485.375ZM774.703 486.828H770.344V488.281H774.703V486.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.156 486.828H774.703V488.281H776.156V486.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 486.828H776.156V488.281H777.609V486.828Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 486.828H777.609V488.281H779.062V486.828Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.344 488.281H768.891V489.734H770.344V488.281ZM773.25 488.281H771.797V489.734H773.25V488.281Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.703 488.281H773.25V489.734H774.703V488.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 488.281H774.703V489.734H777.609V488.281ZM770.344 489.734H768.891V491.188H770.344V489.734ZM773.25 489.734H771.797V491.188H773.25V489.734Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.156 489.734H773.25V491.188H776.156V489.734Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 489.734H776.156V491.188H777.609V489.734ZM773.25 491.188H771.797V492.641H773.25V491.188ZM777.609 491.188H776.156V492.641H777.609V491.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.344 454.859H768.891V456.312H770.344V454.859ZM776.156 454.859H771.797V456.312H776.156V454.859ZM777.609 456.312H767.438V457.766H777.609V456.312ZM777.609 457.766H765.984V459.219H777.609V457.766Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.438 459.219H764.531V460.672H767.438V459.219Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 459.219H767.438V460.672H777.609V459.219Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 459.219H777.609V460.672H781.969V459.219ZM771.797 460.672H763.078V462.125H771.797V460.672Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 460.672H771.797V462.125H777.609V460.672Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 460.672H777.609V462.125H783.422V460.672ZM776.156 462.125H763.078V463.578H776.156V462.125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.609 462.125H776.156V463.578H777.609V462.125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 462.125H777.609V463.578H783.422V462.125ZM784.875 463.578H761.625V465.031H784.875V463.578ZM784.875 465.031H761.625V466.484H784.875V465.031ZM784.875 466.484H761.625V467.938H784.875V466.484ZM784.875 467.938H761.625V469.391H784.875V467.938ZM784.875 469.391H761.625V470.844H784.875V469.391ZM784.875 470.844H761.625V472.297H784.875V470.844ZM784.875 472.297H761.625V473.75H784.875V472.297ZM784.875 473.75H761.625V475.203H784.875V473.75ZM773.25 475.203H761.625V476.656H773.25V475.203Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 475.203H773.25V476.656H779.062V475.203Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.875 475.203H779.062V476.656H784.875V475.203ZM773.25 476.656H761.625V478.109H773.25V476.656Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 476.656H773.25V478.109H781.969V476.656Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.875 476.656H781.969V478.109H784.875V476.656ZM773.25 478.109H761.625V479.562H773.25V478.109Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 478.109H773.25V479.562H779.062V478.109Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.875 478.109H779.062V479.562H784.875V478.109ZM773.25 479.562H761.625V481.016H773.25V479.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 479.562H773.25V481.016H779.062V479.562Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.875 479.562H779.062V481.016H784.875V479.562Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.25 466.484H764.531V467.938H773.25V466.484ZM783.422 466.484H774.703V467.938H783.422V466.484ZM765.984 467.938H764.531V469.391H765.984V467.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.891 467.938H765.984V469.391H768.891V467.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.797 467.938H768.891V469.391H771.797V467.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.25 467.938H771.797V469.391H773.25V467.938ZM776.156 467.938H774.703V469.391H776.156V467.938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 467.938H776.156V469.391H779.062V467.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 467.938H779.062V469.391H781.969V467.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 467.938H781.969V469.391H783.422V467.938ZM765.984 469.391H760.172V470.844H765.984V469.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.891 469.391H765.984V470.844H768.891V469.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.797 469.391H768.891V470.844H771.797V469.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.156 469.391H771.797V470.844H776.156V469.391Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 469.391H776.156V470.844H779.062V469.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 469.391H779.062V470.844H781.969V469.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 469.391H781.969V470.844H783.422V469.391ZM761.625 470.844H760.172V472.297H761.625V470.844ZM765.984 470.844H764.531V472.297H765.984V470.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.891 470.844H765.984V472.297H768.891V470.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.797 470.844H768.891V472.297H771.797V470.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.25 470.844H771.797V472.297H773.25V470.844ZM776.156 470.844H774.703V472.297H776.156V470.844Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 470.844H776.156V472.297H779.062V470.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 470.844H779.062V472.297H781.969V470.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 470.844H781.969V472.297H783.422V470.844ZM761.625 472.297H760.172V473.75H761.625V472.297ZM765.984 472.297H764.531V473.75H765.984V472.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.891 472.297H765.984V473.75H768.891V472.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.797 472.297H768.891V473.75H771.797V472.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.25 472.297H771.797V473.75H773.25V472.297ZM776.156 472.297H774.703V473.75H776.156V472.297Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.062 472.297H776.156V473.75H779.062V472.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.969 472.297H779.062V473.75H781.969V472.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.422 472.297H781.969V473.75H783.422V472.297ZM773.25 473.75H764.531V475.203H773.25V473.75ZM783.422 473.75H774.703V475.203H783.422V473.75Z",
    fill: "#F3322C"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M737 240.5L643 312",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M735 464L597 413",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241 426L157 465",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M269 289L77 194",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_230_1751",
    x: 316,
    y: 219.537,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_230_1751",
    x: 277,
    y: 180.537,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_230_1751",
    x: 237,
    y: 140.537,
    width: 398,
    height: 398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_230_1751",
    x: 285.005,
    y: 201.029,
    width: 302.764,
    height: 302.764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.25,
    result: "effect1_foregroundBlur_230_1751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_230_1751",
    x: 285.969,
    y: 176.775,
    width: 46.5073,
    height: 46.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_230_1751",
    x: 298.5,
    y: 187.586,
    width: 21.5,
    height: 23.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_230_1751",
    x: 419.969,
    y: 162.775,
    width: 46.5073,
    height: 46.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_230_1751",
    x: 432.5,
    y: 173.586,
    width: 21.5,
    height: 23.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_230_1751",
    x: 265.969,
    y: 275.775,
    width: 46.5073,
    height: 46.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_230_1751",
    x: 278.5,
    y: 286.586,
    width: 21.5,
    height: 23.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_230_1751",
    x: 601.969,
    y: 304.775,
    width: 46.5073,
    height: 46.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_230_1751",
    x: 614.5,
    y: 315.586,
    width: 21.5,
    height: 23.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_230_1751",
    x: 237.525,
    y: 386.33,
    width: 58.5073,
    height: 58.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_230_1751",
    x: 253.22,
    y: 399.883,
    width: 27.195,
    height: 30.7949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_230_1751",
    x: 544.969,
    y: 375.775,
    width: 58.5073,
    height: 58.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_230_1751",
    x: 560.664,
    y: 389.329,
    width: 27.195,
    height: 30.7944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_230_1751",
    x: 492.969,
    y: 184.775,
    width: 58.5073,
    height: 58.5079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.51565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_230_1751",
    x: 508.664,
    y: 198.329,
    width: 27.195,
    height: 30.7944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_230_1751",
    x: 400,
    y: 0,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.709804 0 0 0 0 0.913725 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_230_1751",
    x: 195,
    y: 26,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.619608 0 0 0 0 0.392157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_230_1751",
    x: 0,
    y: 130,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.843137 0 0 0 0 0.678431 0 0 0 0 0.239216 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_230_1751",
    x: 62,
    y: 432,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_230_1751",
    x: 599,
    y: 2,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_230_1751",
    x: 731,
    y: 164,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.364706 0 0 0 0 0.505882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_230_1751",
    x: 727.5,
    y: 428,
    width: 91.5,
    height: 91.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.619608 0 0 0 0 0.392157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_230_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_230_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_1751",
    x1: 297.97,
    y1: 185.251,
    x2: 324.99,
    y2: 191.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_230_1751",
    x1: 431.97,
    y1: 171.251,
    x2: 458.99,
    y2: 177.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_230_1751",
    x1: 277.97,
    y1: 284.251,
    x2: 304.99,
    y2: 290.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_230_1751",
    x1: 613.97,
    y1: 313.251,
    x2: 640.99,
    y2: 319.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_230_1751",
    x1: 250.779,
    y1: 395.333,
    x2: 289.198,
    y2: 403.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_230_1751",
    x1: 558.223,
    y1: 384.779,
    x2: 596.642,
    y2: 393.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_230_1751",
    x1: 506.223,
    y1: 193.779,
    x2: 544.642,
    y2: 202.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_1751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 823,
    height: 539,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiRaidFeature);
export default __webpack_public_path__ + "static/media/antiRaidFeature.e179ca91aa223b209bc822f99bbc3370.svg";
export { ForwardRef as ReactComponent };